import { Box, Typography } from '@mui/material';
import { isValidElement, ReactNode } from 'react';

interface Props {
  label: string;
  value: ReactNode;
}

const DetailItem = ({ label, value }: Props) => {
  const isReactComponent = isValidElement(value);
  return (
    <Box mb={1} mt={isReactComponent ? 2 : 1} ml={2} mr={2}>
      <Typography variant="h3">{label}</Typography>
      {isReactComponent ? value : <Typography variant="body2">{value}</Typography>}
    </Box>
  );
};

export default DetailItem;
